// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {use_siteicon} from '../ui/use_siteicon';
import {use_screen} from '../lib/screen_util';
import {Button} from '../../../shared/button';
import {Install_btn} from '../ui/install_btn';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './access_domain_hero.module.less';

interface i_access_domain_hero_props {
    domain: string;
}

export const Access_domain_hero = (props: i_access_domain_hero_props)=>{
    const {theme} = useContext(Settings_context);
    const {icon_link} = use_siteicon({link: props.domain, quality: 60});
    const {screen} = use_screen();
    const is_mobile = screen=='xs' || screen=='sm';
    const install_btn_cls = cn(['hola_btn hola_btn--round hola_btn-no_arrow',
        !is_mobile && 'hola_btn--lg',
        'hola_btn--txt_colored hola_btn--no_jump',
        styles.button]);
    return <div className={styles.access_domain_hero}>
      <div className={cn([theme.container, styles.content])}>
        <div className={styles.img_container}>
          <img src={icon_link} className={styles.img}
            alt={`${props.domain} icon`}/>
        </div>
        <div className={styles.content_container}>
          <div className={styles.header_container}>
            <h1 className={theme.H2}>
              Access <span className={styles.coloured}>{props.domain}</span>
              {is_mobile && <br/>}
              &nbsp;from anywhere
            </h1>
            <p className={theme.u3}>
              Install Hola VPN, pick a location, and open&nbsp;
              <a href={props.domain} className={cn([theme.link, theme.u3])}>
                {props.domain}</a>. It takes seconds.
            </p>
          </div>
          <div className={styles.buttons}>
            <Install_btn keep_btn_text text="Get Hola Free VPN"
              no_redirect className={install_btn_cls}/>
            <Button cls={styles.button} caption="See Premium"
              to="/premium" color="transparent"
              size={is_mobile ? 'md' : 'lg'}/>
          </div>
        </div>
      </div>
    </div>;
};

interface i_access_domain_hero_editor_props {
    value: i_access_domain_hero_props;
    on_change: (new_val: i_access_domain_hero_props)=>void;
}

export const Access_domain_hero_editor = (
props: i_access_domain_hero_editor_props)=>{
    return <Editor value={props.value} on_change={props.on_change}
      editors={[]}/>;
};
